<script setup lang="ts">
import IOHeroContentMenuBuffer from "@/components/io/io-hero/content/IOHeroContentMenuBuffer.vue";
const props = withDefaults(defineProps<{
  id: string,
  w?: string,
  content: Record<string, any>
}>(), {
  id: '',
  w: 'w-full max-w-100% mx-auto grid grid-cols-[1fr] g-1 gpt-1.5 gpb-4 t:gpt-1.5 t:gpb-4 ds:gpb-2 gpt-0',
  content: () => {
    return {
      hairline: '',
      title: '',
      description: '',
      line: true,
      lineColor: 'white',
    }
  }
})

const content = computed(() => props.content)

const hairline = computed(() => content.value.hairline)
const title = computed(() => content.value.title)
const description = computed(() => content.value.description)
const line = computed(() => content.value.line)
const lineColor = computed(() => content.value.lineColor)

const route = useRoute()

const routeName = computed(() => route.name)


const glassbg = ref(null)

function handleMousemove(e: MouseEvent) {
  const container = e.currentTarget as HTMLElement;
  const rect = container.getBoundingClientRect();
  const paddingValue = 70;
  const x = e.clientX - rect.left - paddingValue;
  const y = e.clientY - rect.top - paddingValue;
  // Use the ref "glassbg" to update the mask's position on the background layer
  if (glassbg.value) {
    glassbg.value.classList.add('active');
    (glassbg.value as HTMLElement).style.setProperty('--mouse-x', `${x}px`);
    (glassbg.value as HTMLElement).style.setProperty('--mouse-y', `${y}px`);
  }
}

const titleCountClass = computed(() => {
  if (title.value && title.value.length >= 0 && title.value.length < 20) {
    return 'title-20';
  } else if (title.value && title.value.length >= 20 && title.value.length < 40) {
    return 'title-20-40';
  } else if (title.value && title.value.length >= 40 && title.value.length < 60) {
    return 'title-40-60';
  } else if (title.value && title.value.length >= 60 && title.value.length < 80) {
    return 'title-60-80';
  } else if (title.value && title.value.length >= 80 && title.value.length < 100) {
    return 'title-80-100';
  } else if (title.value && title.value.length >= 100) {
    return 'title-100';
  }
  return '';
})

function resetMask(e: MouseEvent) {
  if (glassbg.value) {
    glassbg.value.classList.remove('active');
  }
  // if (glassbg.value) {
  //   (glassbg.value as HTMLElement).style.setProperty('--mouse-x', '50%');
  //   (glassbg.value as HTMLElement).style.setProperty('--mouse-y', '50%');
  // }
}
</script>

<template>
  <div class="io-hero-content hero-slide content-content" :class="[id, routeName]">

    <IOHeroContentMenuBuffer class="menu-buffer":id="id" />

    <div class="content-container" :class="w">
      <Column class="col-content glass-container relative d:max-w-1000px" @mousemove="handleMousemove"
      @mouseleave="resetMask" >
      
        <!-- Background layer with glass effect -->
        <div ref="glassbg" class="glass-background"
        ></div>
        <!-- Text content layer -->
        <div class="glass-content grid g-1.5" >
          <div class="io-h-hairline" v-if="hairline" v-html="hairline" />

          <div class="io-h-primary-title" :class="titleCountClass" v-html="title" />
          <div class="io-h-line" v-if="line">
            <div class="line" :style="{ backgroundColor: lineColor }" />
          </div>
          <div class="io-h-description gpb-2" v-if="description" v-html="description" />
        </div>
  
        <!-- I now just need to figure out how how to set the height of this to auto, with a prefended min height baed on the page in question, and if the content proceeds further it transitions the auto height accordingly, -->

      </Column>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.io-hero-content {

  display: flex;
  align-items: center;
  justify-content: center;
  // transform: translate(-70px, -70px) !important;


  .io-content-menu-buffer {

  }

  .menu-buffer {
    //box-shadow: inset 0 0 0 1px red;
  }

  .content-container {
    width: 100%;

    max-width: 92%;
    // box-shadow: inset 0 0 0 1px green;
   

    .col-content {

      // border: 1px solid red;

      // box-shadow: inset 0 0 0 1px blue;

      &.glass-container {
        // padding: 70px;
        transition: all 0.2s ease;
        .glass-background {
          --mask-radius: 70px; /* Sets the radius to 70 pixels */
          
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          right: 0;
          bottom: 0;
          border-radius: 16px;
          backdrop-filter: blur(5px);
          // background: red;
          height: calc(100% - 140px);
          width: calc(100% - 140px);

          /* By default, no mask effect */
          mask-image: none;
          -webkit-mask-image: none;
          transition: mask-image 0.3s, -webkit-mask-image 0.3s, mask-position 0.1s;
          z-index: 1;
          // background: red;

          transition: all 0.5s ease;


          &.active {
          /* On hover, reveal a circular window using a radial gradient.
              Here, --mask-radius controls the transparent area (increase to enlarge).
              The gradient transitions from transparent to opaque (black). */
            mask-image: radial-gradient(
              circle at var(--mouse-x, 50%) var(--mouse-y, 50%),
              transparent var(--mask-radius, 70px),
              black calc(var(--mask-radius, 70px) + 30px)
            );
            -webkit-mask-image: radial-gradient(
              circle at var(--mouse-x, 50%) var(--mouse-y, 50%),
              transparent var(--mask-radius, 70px),
              black calc(var(--mask-radius, 70px) + 30px)
            );
          }
          
        }

        .glass-content {
          position: relative;
          z-index: 2;
        }
      }
   

      &.glass-effect {
        border-radius: 16px;
        // box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
        backdrop-filter: blur(5px);
        padding: gr(1.5);
        transition: opacity 0.5s ease; // Fade-in transition on load

        mask-image: radial-gradient(
          circle at var(--mouse-x, 50%) var(--mouse-y, 50%),
          transparent 50px,
          black 80px
        );
        -webkit-mask-image: radial-gradient(
          circle at var(--mouse-x, 50%) var(--mouse-y, 50%),
          transparent 50px,
          black 80px
        );
      }

      .io-h-hairline {
        font-size: fs(-0.5);
        color: white;
        @apply tracking-widest;
      }

      .io-h-primary-title {
        // font-size: fs(9);
        color: white;
        font-weight: 200;
        // line-height: gr(3.25);

        // font-size: min(10vw, fs(9));
        font-size: clamp(fs(0), fs(8), fs(8));
        line-height: 1.2;

        @include mq($until: mlx) {
          font-size: clamp(fs(0), fs(7), fs(7));
          max-width: 96%;
        }
        @include mq($from: mlx, $until: t) {
          font-size: clamp(fs(0), fs(7), fs(7));
        }

        @include mq($from: t, $until: d) {
          font-size: clamp(fs(0), fs(7), fs(7));
          max-width: 92%;
        }
        @include mq($from: d) {
          font-size: clamp(fs(0), 10vw, fs(9));
        };


       

        * {
          font-family: var(--quicksand);
        }
      }

      .io-h-line {
        .line {
          width: 100px;
          height: 1px;
          background-color: white;
        }
      }

      .io-h-description {
        font-size: fs(1);

          color: white;

        // :deep(span) {
        //   color: var(--c-light-green);
        // }

        font-size: clamp(fs(0), 2.5vw, fs(1));
        line-height: 2;

        @include mq($until: mlx) {
          font-size: clamp(fs(0), 2.5vw, fs(1));
          max-width: 96%;
        }
        @include mq($from: mlx, $until: t) {
          font-size: clamp(fs(0), 3vw, fs(1));
        }

        @include mq($from: t, $until: d) {
          font-size: clamp(fs(0), 2.25vw, fs(1));
          max-width: 92%;
        }
        @include mq($from: d) {
          font-size: clamp(fs(0), 10vw, fs(1));
        };

        

      }
    }

    
  }




}
</style>
